import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Tarification, Stock, GarantieI, Prime, TarificationCheck, ListeDocs, Remorque, Assurance } from '../../shared/model';
import { BehaviorSubject } from 'rxjs';
import { DatabaseConnection } from '../../shared/services/database-connection';



@Injectable({
  providedIn: 'root',
})
export class AssuranceService {

  constructor(
    private http : HttpClient,
    private  dbConnection : DatabaseConnection
  ){}

  listeDocumenst(){
    return this.http.get<ListeDocs>(this.dbConnection.remoteApiConnection.value + "liste-compagnie-docs")
  }
  listeGarantie(){
    return this.http.get<GarantieI[]>(this.dbConnection.remoteApiConnection.value + "liste-garantie")
  }


  /*checkTarification(data : TarificationCheck){
    return this.http.post<Prime>(this.dbConnection.remoteApiConnection.value + 'check-tarification', data)
  }*/

  checkVignette(vehicule_id : string){
    return this.http.get<boolean>(this.dbConnection.remoteApiConnection.value + 'check-vignette?vehicule='+vehicule_id)
  }

  saveAssurance(data : any){
    return this.http.post<any>(this.dbConnection.remoteApiConnection.value + 'save-tarification', data)
  }

  getAssurance(vehicule_id : string){
    return this.http.get<Assurance>(this.dbConnection.remoteApiConnection.value + 'assurance-vehicule/'+vehicule_id)
  }

  /*joinTrailer(data : any){
    return this.http.post<Remorque>(this.dbConnection.remoteApiConnection.value + 'join-trailer', data)
  }*/

}
